import React from 'react';
import { Link } from 'gatsby';

class Footer extends React.Component {
  render() {
    return (
      <footer className="site-footer">
        <div className="footer_inner">
          <div className="container">
            <div className="footer-bottom social-right-menu ">
              <div className="site-info">
                <Link to="/legal">Mentions Légales</Link>
                <br />
                {`© ${new Date().getFullYear()} Loc-Event 91 Tous droits réservés.`}
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
